export default {
  CHANGE_VALUE: 'CHANGE_VALUE',
  ADD_VEHICLE: 'ADD_VEHICLE',
};
